var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fullview"},[_c('div',{staticClass:"loading-spacer"}),_vm._v(" "),_c('vue-loading',{attrs:{"type":"bubbles","color":"#4cb433","size":{ width: '100px', height: '100px' }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }